export default "__VITE_ASSET__0ff_clLO__"